import {
  type HTMLAttributes,
  type TdHTMLAttributes,
  type ThHTMLAttributes,
  type ReactNode,
} from 'react';
import { cn } from './cn';

export interface TableProps extends HTMLAttributes<HTMLTableElement> {
  stickyHeader?: boolean;
  children: ReactNode;
}

export function Table({ stickyHeader, className, children, ...rest }: TableProps) {
  return (
    <div className={cn('ui-table-wrap', stickyHeader && 'ui-table-wrap--sticky')}>
      <table className={cn('ui-table', className)} {...rest}>
        {children}
      </table>
    </div>
  );
}

export function TableHead({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead className={cn('ui-table__head', className)} {...rest}>
      {children}
    </thead>
  );
}

export function TableBody({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody className={cn('ui-table__body', className)} {...rest}>
      {children}
    </tbody>
  );
}

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  interactive?: boolean;
  selected?: boolean;
}

export function TableRow({ interactive, selected, className, children, ...rest }: TableRowProps) {
  return (
    <tr
      className={cn(
        'ui-table__row',
        interactive && 'ui-table__row--interactive',
        selected && 'ui-table__row--selected',
        className
      )}
      aria-selected={selected || undefined}
      {...rest}
    >
      {children}
    </tr>
  );
}

export function TableHeaderCell({
  className,
  children,
  ...rest
}: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th scope="col" className={cn('ui-table__th', className)} {...rest}>
      {children}
    </th>
  );
}

export function TableCell({
  className,
  children,
  ...rest
}: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={cn('ui-table__td', className)} {...rest}>
      {children}
    </td>
  );
}
